import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape, bibFieldShape } from '@bibliocommons/bc-prop-types';
import { selectContributorNames, selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentMovie } from 'app/selectors/MoviesSelector';
import Contributors from './Contributors';

export class ContributorsContainer extends React.PureComponent {
  render() {
    return <Contributors {...this.props} />;
  }
}

ContributorsContainer.propTypes = {
  bib: bibShape.isRequired,
  movie: ImmutablePropTypes.map,
  contributorNames: bibFieldShape
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  const metadataId = catalogBib.get('metadataId');
  const bib = selectBibEntities(state).get(metadataId);

  return {
    bib,
    movie: selectCurrentMovie(state),
    contributorNames: selectContributorNames(state)
  };
};

export default connect(mapStateToProps)(ContributorsContainer);
